import { ParsedUrlQuery } from 'querystring';
import { getQueryVariables } from '~/jobiqo/components/Search/utils/searchHelpers';
import { MINI_SITE_TAB_QUERYSTRING_KEY } from './components/constants';

export const MINI_SITE_ORGANIZATION_SEARCH_FIELD = 'job_organization_id';

export const getMiniSiteSearchQuerystring = (
  query: ParsedUrlQuery,
): ParsedUrlQuery => {
  const searchQuerystring = { ...query };

  delete searchQuerystring.path;
  delete searchQuerystring.subpath;
  delete searchQuerystring[MINI_SITE_TAB_QUERYSTRING_KEY];

  return searchQuerystring;
};

export const isMiniSiteJobSearchQuery = (query: ParsedUrlQuery): boolean => {
  const querystring = getMiniSiteSearchQuerystring(query);

  return !!(
    query?.[MINI_SITE_TAB_QUERYSTRING_KEY] === 'jobs' ||
    querystring.jobId ||
    querystring.search ||
    querystring.page
  );
};

export const getMiniSiteJobsPath = (organizationPath: string): string => {
  const normalizedPath =
    organizationPath === '/'
      ? organizationPath
      : organizationPath.replace(/\/$/, '');

  return `${normalizedPath}/jobs`;
};

export const getMiniSiteOrganizationConditionGroup = (
  organizationId: number,
) => ({
  conjunction: 'OR',
  conditions: [
    {
      name: MINI_SITE_ORGANIZATION_SEARCH_FIELD,
      operator: '=',
      value: String(organizationId),
    },
  ],
});

export const getMiniSiteJobSearchVariables = ({
  querystring,
  itemsPerPage,
  language,
  organizationId,
}: {
  querystring: ParsedUrlQuery;
  itemsPerPage: number;
  language?: string;
  organizationId: number;
}) => {
  const variables = getQueryVariables(querystring, itemsPerPage, [], language);

  return {
    ...variables,
    facets: [],
    condition_group: {
      ...variables.condition_group,
      groups: [
        ...(variables.condition_group.groups ?? []),
        getMiniSiteOrganizationConditionGroup(organizationId),
      ],
    },
  };
};
